import { styled } from 'styled-components'

import { Typography } from 'designSystem'

export const LocationDepotTypography = styled(Typography)`
  line-height: 13px;
`
